import React from "react";
import { graphql } from "gatsby";
import {
  Layout,
  Container,
  Grid,
  Column,
  Link,
  Pagination,
  BlogPostSidebar,
  PersonBadge,
  Breadcrumb,
} from "../../../src/components";
import { formatDate } from "../../../src/util/date";
import { crumbsFromLocation } from "../../../src/util/breadcrumb-resolver";

import "./styles/post.scss";

const BlogArchive = ({ data, pageContext, location, ...props }) => {
  const crumbs = crumbsFromLocation(location);

  const posts = data.allWordpressPost.edges;

  const pageTitle =
    pageContext.currentPage !== 1
      ? `Puppet Blog - Page ${pageContext.currentPage &&
          pageContext.currentPage}`
      : "Puppet Blog";

  const getPosts = () => {
    if (posts) {
      return posts.map(post => {
        const postMeta = JSON.parse(post.node.meta_fields_json);
        const author =
          postMeta.author &&
          postMeta.author[0] &&
          postMeta.author[0].fields &&
          postMeta.author[0].fields.first_name &&
          postMeta.author[0].fields.last_name &&
          `${postMeta.author[0].fields.first_name} ${postMeta.author[0].fields.last_name}`;

        const postDate = new Date(Date.parse(post.node.date));

        const getAuthorBadge = () => {
          const authorPhoto = postMeta.author[0]
            ? postMeta.author[0].fields.headshot
              ? postMeta.author[0].fields.headshot
              : { url: "/defaults/headshot.png", alt: "" }
            : null;

          if (author) {
            return (
              <PersonBadge
                image={authorPhoto}
              />
            );
          } else {
            return "";
          }
        };


        let categories = null;
        const taxCategories = JSON.parse(post.node.taxonomy_category_json);
        if (taxCategories && taxCategories.length > 0) {
          categories = (
            <div className="pm-blog-list__categories pm-font-size--xs">
              {taxCategories.map((category, index) => (
                <span key={`category_${category.slug}`}>
                  <Link url={`/blog/category/${category.slug}`}><span dangerouslySetInnerHTML={{ __html: category.name }}/></Link>
                  {index + 1 < taxCategories.length
                    ? index + 2 == taxCategories.length
                      ? <span className='pm-textColor--darkgrey'> and </span>
                      : ", "
                    : null}
                </span>
              ))}
            </div>
          );
        }

        return (
          <div key={post.node.guid} className="pm-blog-list__item">
            <div className="pm-blog-list__item__post">
              <Link isUnstyled={true} url={post.node.path}>
                <h4 className="pm-blog-list__item__title" dangerouslySetInnerHTML={{__html: post.node.title}} />
                <div className="pm-blog-list__item__body">
                  <div className="pm-blog-list__headshot">{getAuthorBadge()}</div>
                  <div className="pm-blog-list__copy">
                    <div className="pm-blog-list__item__byline">by {author} | {formatDate(postDate)}</div>
                    <div className="pm-blog-list__item__excerpt" dangerouslySetInnerHTML={{__html: post.node.excerpt}} />
                  </div>
                </div>
              </Link>
              {categories && categories}
            </div>
          </div>
        );
      });
    } else {
      return false;
    }
  };

  const pageMeta = {title: pageTitle, canonicalUrl: pageContext.uri, description: "Welcome to the Puppet Blog." }

  return (
    <Layout meta={pageMeta}>
      <Container>
        <Breadcrumb breadcrumbs={crumbs}/>
      </Container>
      <Container>
        <Grid>
          <Column  aboveSm={{ span: 8 }} aboveLg={{ span: 7, offset: 1 }}>
            <h1 className="pm-margin-top--xl">{pageTitle}</h1>
            { getPosts() }

            <Pagination
              basePath="/blog"
              numPages={pageContext.numPostPages && pageContext.numPostPages}
              currentPage={pageContext.currentPage && pageContext.currentPage}
            />
          </Column>
          <Column
            aboveSm={{ span: 4 }}
            aboveMd={{ span: 3, offset: 9 }}
            >
            <div className="pm-margin-top--xl">
              <BlogPostSidebar categories={data.allWordpressCategory} />
            </div>
          </Column>
        </Grid>
      </Container>
    </Layout>
  );
};

export const query = graphql`
  query blogListQuery($skip: Int!, $limit: Int!, $hiddenCategories: [String]!) {
    allWordpressPost(
      sort: { fields: date, order: DESC }
      limit: $limit
      skip: $skip
      filter: {categories: {elemMatch: {slug: {nin: $hiddenCategories}}}}
    ) {
      edges {
        node {
          title
          date
          excerpt
          guid
          path
          slug
          status
          taxonomy_category_json
          meta_fields_json
        }
      }
    }
    allWordpressCategory(filter: {slug: {nin: $hiddenCategories}}) {
      nodes {
        name
        path
        slug
        count
      }
    }
  }
`;

export default BlogArchive;
